import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import QRCode from 'qrcode';
import { CUSTOMER_URL } from '../../../../config/constants';

const CustomerQrModal = ({ user }) => {
  const [qrCode, setQrCode] = useState(null);

  const base64urlencodeString = (str) =>
    btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

  useEffect(() => {
    const generateQrCode = async () => {
      if (user) {
        try {
          const url = CUSTOMER_URL;
          const rawValue = `${user.identificationTypeId}-${user.idDocumentNumber}`;
          const userValue = base64urlencodeString(rawValue);
          const value = `${url}${userValue}`;
          const qrString = await QRCode.toDataURL(value, {
            errorCorrectionLevel: 'H',
            type: 'image/jpeg',
            scale: 6,
          });
          setQrCode(qrString);
        } catch (error) {
          console.error('Error generating QR Code:', error);
        }
      }
    };

    generateQrCode();
  }, [user]);

  return (
    <div>
      {qrCode && (
        <div className="text-center mt-4">
          <img src={qrCode} alt="User QR Code" className="img-fluid" />
        </div>
      )}
    </div>
  );
};

CustomerQrModal.propTypes = {
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    identificationTypeId: PropTypes.number,
    idDocumentNumber: PropTypes.number,
  }).isRequired,
};

const mapStateToProps = ({ UserUnit }) => ({
  user: UserUnit.Customer.getIn(['current', 'content']).toJS(),
});

export default connect(mapStateToProps, null)(CustomerQrModal);
